import { InterstitialAd } from './iframed/InterstitialAd';

interface AdConfig {
  container?: HTMLDivElement;
  element: string;
  type: 'reward' | 'pre-roll';
  autoPlay: boolean;
  finalCallback: () => void;
  onCTAStateChange: (e: { isShowing: boolean }) => void;
  CTAScreenConfig: {
    buttonArrowClass: string;
    buttonClass: string;
    buttonText: string;
    buttonTextClass: string;
    colLeftClass: string;
    colRightClass: string;
    containerClass: string;
    messageBoxClass: string;
    messageText: string;
  };
}

class AdVideo {
  render(setConfig: AdConfig) {
    const config = setConfig || window.videoAdConfigs;
    const container = config.container || document.getElementById('ark_pre-roll') as HTMLDivElement;
    const onFinish = config.finalCallback || (() => container.dispatchEvent(new Event("onPrerollEnd")));

    if (!container) return setTimeout(() => this.render(config), 1000);

    const interstitialAd = new InterstitialAd({ container, onFinish });
    return interstitialAd;
  }
}

const w = window as any;
w.__ark_ads__ = w.__ark_ads__ || {};
w.__ark_ads__.AdVideo = AdVideo;

